import { render } from "./VehicleItemDetail.vue?vue&type=template&id=275e2098&scoped=true"
import script from "./VehicleItemDetail.vue?vue&type=script&lang=js"
export * from "./VehicleItemDetail.vue?vue&type=script&lang=js"

import "./VehicleItemDetail.vue?vue&type=style&index=0&id=275e2098&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275e2098"]])

export default __exports__